/**
 * @fileoverview Título de seção do editor de triagem com a regra de
 * funcionamento num ⓘ ao lado: a dica aparece ao passar o mouse, ao focar pelo
 * teclado ou ao tocar. As regras saem da tela para ela não ficar cheia de texto;
 * na tela fica só o título, em forma de situação ("Quando a triagem terminar").
 */

import React from "react";
import Tooltip from "@material-ui/core/Tooltip";
import { Info } from "lucide-react";

import { i18n } from "../../../../translate/i18n";
import useStyles from "./styles";

export const InfoTip = ({ text }) => {
  const classes = useStyles();
  return (
    <Tooltip title={text} placement="top" enterTouchDelay={0} leaveTouchDelay={8000} classes={{ tooltip: classes.infoTooltip }}>
      <button type="button" className={classes.infoBtn} aria-label={i18n.t("triage.manager.editor.howItWorks")}>
        <Info />
      </button>
    </Tooltip>
  );
};

const SectionTitle = ({ title, info }) => {
  const classes = useStyles();
  return (
    <div className={classes.titleRow}>
      <span className={classes.sectionTitle}>{title}</span>
      {info && <InfoTip text={info} />}
    </div>
  );
};

export default SectionTitle;
